module.exports = __webpack_public_path__ + "static/img/introduceBTypeBIcon2.33bb051.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/introduceBTypeBIcon2.png
// module id = bQhC
// module chunks = 0